import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { STUDY_PLAN_METRICS_TRANSLATION_KEY } from "./constants";
var translationsPt = {
  pt: /*#__PURE__*/_defineProperty({}, STUDY_PLAN_METRICS_TRANSLATION_KEY, {
    CREATE_STUDY_PLAN: 'Criar plano de estudos',
    EDIT_STUDY_PLAN_SHORT: 'Criar plano',
    // Activity
    ACTIVITY_TITLE: 'Objetivo semanal',
    MINUTE_COUNT: '{{progress}}/{{total}} min',
    ACTIVITY_EMPTY_LABEL: 'Bom começo de semana! É hora de ir para a aula',
    ACTIVITY_EMPTY_3_DAYS_LABEL: 'Você não assistiu nenhuma aula esta semana, comece hoje!!',
    ACTIVITY_IN_PROGRESS_LABEL: 'Seu ritmo está bom, continue aprendendo assim!',
    ACTIVITY_ALMOST_COMPLETED_LABEL: 'Você está muito perto do seu objetivo semanal, continue assim!',
    ACTIVITY_COMPLETED_LABEL: 'Bom trabalho! Você completou seu objetivo semanal',
    ACTIVITY_EXCEDED_LABEL: 'Que trabalho incrível! Você superou seu objetivo semanal',
    WEEKLY_TARGET: 'Seu objetivo semanal é de {{minutes}} minutos',
    CHANGE_WEEKLY_TARGET: 'Seu objetivo semanal de {{minutes}} minutos não está funcionando. Você pode modificá-lo',
    CHANGE_WEEKLY_TARGET_CTA: 'aqui',
    // Progress
    PROGRESS_TITLE: 'Seu progresso esta semana',
    // Empty view
    EMPTY_VIEW_TITLE: 'Você ainda não começou seu processo de aprendizagem',
    EMPTY_VIEW_DESC: 'Descubra conteúdos do seu interesse',
    EMPTY_VIEW_BUTTON: 'Ver conteúdos para você',
    // Error
    STUDY_PLAN_ERROR: 'Ocorreu um erro ao obter suas informações de progresso.',
    STUDY_PLAN_ERROR_DESCRIPTION: 'Parece que ocorreu um problema e não conseguimos realizar esta ação. Recomendamos que você tente novamente.',
    STUDY_PLAN_RETRY_BUTTON_LABEL: 'Carregar de novo',
    LEARNING_PLAN_COMPLETED_COURSES: 'Cursos obrigatórios',
    LEARNING_PLAN_COMPLETED_COURSES_TOOLTIP: 'Total de cursos finalizados em relação aos cursos obrigatórios atribuídos à sua rota.',
    LEARNING_PLAN_COMPLETED_TRACKS: 'Rotas finalizadas',
    LEARNING_PLAN_COMPLETED_TRACKS_TOOLTIP: 'Total de rotas finalizadas em relação às rotas obrigatórias atribuídas a você.',
    LEARNING_PLAN_COMPLETED_PROJECTS: 'Projetos aprovados',
    LEARNING_PLAN_COMPLETED_PROJECTS_TOOLTIP: 'Total de projetos finalizados em relação aos projetos obrigatórios atribuídos a você.',
    LEARNING_PLAN_COMPLETED_ADDITIONAL_COURSES: 'Cursos adicionais',
    LEARNING_PLAN_COMPLETED_ADDITIONAL_COURSES_TOOLTIP: 'O total de cursos finalizados em relação aos cursos atribuídos a você / inscritos fora de uma rota.',
    LEARNING_PLAN_EDIT_STUDY_PLAN_TITLE: 'Você ainda não criou um plano de estudos',
    LEARNING_PLAN_EDIT_STUDY_PLAN_DESC: 'Organize a sua semana para alcançar seus objetivos de aprendizagem',
    LEARNING_PLAN_ACTIONS_TITLE: 'Seu progresso até hoje',
    EDIT_STUDY_PLAN: 'Editar'
  })
};
export default translationsPt;